const caddieCpdCategories = {
  Technical: 'Technical Competence',
  Compliance: 'Compliance & Consumer Protection',
  Professionalism: 'Professionalism & Ethics',
  ClientCare: 'Client Care & Practice',
  Derivatives: 'Derivatives',
  FinancialPlanning: 'Financial Planning',
  ForeignExchange: 'Foreign Exchange',
  Insurance: 'Insurance',
  ManagedInvestment: 'Managed Investment',
  MarginLending: 'Margin Lending',
  RM: 'Responsible Managers CPD',
  Securities: 'Securities',
  SMSF: 'SMSF',
  Superannuation: 'Superannuation',
  Taxation: 'Taxation',
  PracticeManagement: 'Practice Management',
  
  // Removed categories from DEC 2022.
  MortgageBroking: 'Mortgage Broking',

  // Renamed categories from DEC 2022.
  General: 'General',
  Deposits: 'Deposit Products & Fixed Interest',
  PersonalSkills: 'Skills',

  // New categories from DEC 2022.
  TaxFinancialAdvice: 'Tax (Financial) Advice',
  AgedCare: 'Aged Care',
  EstatePlanning: 'Estate Planning',
  GenericKnowledge: 'Generic Knowledge',
  Retirement: 'Retirement',
};

export const kaplanCpdType = {
  import: 'import',
  document: 'document'
};

export const getTasaApproval = (row) => {
  const tpbPoints = parseFloat(row['tasa time (hours)']);
  return tpbPoints > 0;
};

// Kaplan categories before 2022
const kaplanCpdCategories = {
  RM: 'K1 - Responsible Manager (Generic Knowledge)',
  GeneralKnowledge: 'K2 - Generic Knowledge',
  FinancialPlanning: 'K3 - Financial Planning',
  PersonalTaxation: 'K4 - Personal Taxation Issues (financial planning stream)',
  Securities: 'K5 - Securities',
  Derivatives: 'K6 - Derivatives',
  ManagedInvestment: 'K7 - Managed Investments',
  FixedInterest: 'K8 - Fixed Interest',
  ForeignExchange: 'K9 - Foreign Exchange',
  Superannuation: 'K10 - Superannuation',
  SMSF: 'K11 - Self Managed Superannuation Funds',
  RetirementIncome: 'K12 - Retirement Income Streams',
  SocialSecurity: 'K13 - Social Security & Aged Care',
  LifeInsurance: 'K14 - Life Insurance',
  GeneralInsurance: 'K15 - General Insurance',
  EstatePlanning: 'K16 - Estate Planning',
  DepositProducts: 'K17 - Deposit Products and Non-cash Facilities',
  MortgageBroking: 'K18 - Credit & Mortgage Broking',
  CommercialLending: 'K19 - Commercial Lending',
  OTCMarkets: 'K20 - Other OTC Markets',
  PracticeManagement: 'K21 - Practice Management',
  PersonalSkills: 'K22 - Personal Skills Development',
  Skills: 'K23 - Skills',
  Taxation: 'K24 - Taxation (specialist stream)',
  Ethics: 'K25 - Ethics',
  MarginLending: 'K26 - Margin Lending and Geared Investments',
  CyberSecurity: 'K27 - Cyber Security',
  RMCredit: 'K28 - Responsible Manager (Credit)',
  ETF: 'K29 - Exchange Traded Funds (ETFs) and portfolio construction',
  CreditFundamentals: 'K30 - Credit Fundamentals',
  TechnicalCompetence: 'F1 - Technical competence',
  ClientCare: 'F2 - Client care and practice',
  RegulatoryCompliance: 'F3 - Regulatory compliance and consumer protection',
  Professionalism: 'F4 - Professionalism and ethics',
  General: 'F5 - General'
};

// Kaplan mapping before 2022
export const kaplanMapping = {
  [kaplanCpdCategories.TechnicalCompetence]: {
    name: caddieCpdCategories.Technical,
    type: kaplanCpdType.import
  },
  [kaplanCpdCategories.ClientCare]: {
    name: caddieCpdCategories.ClientCare,
    type: kaplanCpdType.import
  },
  [kaplanCpdCategories.RegulatoryCompliance]: {
    name: caddieCpdCategories.Compliance,
    type: kaplanCpdType.import
  },
  [kaplanCpdCategories.Professionalism]: {
    name: caddieCpdCategories.Professionalism,
    type: kaplanCpdType.import
  },
  [kaplanCpdCategories.General]: {
    name: caddieCpdCategories.General,
    type: kaplanCpdType.import
  },
  [kaplanCpdCategories.RM]: {
    name: caddieCpdCategories.RM,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.GeneralKnowledge]: {
    name: caddieCpdCategories.General,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.FinancialPlanning]: {
    name: caddieCpdCategories.FinancialPlanning,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.PersonalTaxation]: {
    name: caddieCpdCategories.Taxation,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.Securities]: {
    name: caddieCpdCategories.Securities,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.Derivatives]: {
    name: caddieCpdCategories.Derivatives,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.ManagedInvestment]: {
    name: caddieCpdCategories.ManagedInvestment,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.FixedInterest]: {
    name: caddieCpdCategories.Deposits,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.ForeignExchange]: {
    name: caddieCpdCategories.ForeignExchange,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.Superannuation]: {
    name: caddieCpdCategories.Superannuation,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.SMSF]: {
    name: caddieCpdCategories.SMSF,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.RetirementIncome]: {
    name: caddieCpdCategories.Superannuation,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.SocialSecurity]: {
    name: caddieCpdCategories.Superannuation,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.LifeInsurance]: {
    name: caddieCpdCategories.Insurance,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.GeneralInsurance]: {
    name: caddieCpdCategories.Insurance,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.EstatePlanning]: {
    name: caddieCpdCategories.Superannuation,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.DepositProducts]: {
    name: caddieCpdCategories.Deposits,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.MortgageBroking]: {
    name: caddieCpdCategories.MortgageBroking,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.CommercialLending]: {
    name: caddieCpdCategories.MortgageBroking,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.OTCMarkets]: {
    name: caddieCpdCategories.Securities,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.PracticeManagement]: {
    name: caddieCpdCategories.PracticeManagement,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.PersonalSkills]: {
    name: caddieCpdCategories.PersonalSkills,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.Skills]: {
    name: caddieCpdCategories.PersonalSkills,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.Taxation]: {
    name: caddieCpdCategories.Taxation,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.Ethics]: {
    name: caddieCpdCategories.Professionalism,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.MarginLending]: {
    name: caddieCpdCategories.MarginLending,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.CyberSecurity]: {
    name: caddieCpdCategories.General,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.RMCredit]: {
    name: caddieCpdCategories.RM,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.ETF]: {
    name: caddieCpdCategories.Securities,
    type: kaplanCpdType.document
  },
  [kaplanCpdCategories.CreditFundamentals]: {
    name: caddieCpdCategories.MortgageBroking,
    type: kaplanCpdType.document
  }
};

/**
 * All the settings for the Kaplan import tool from 2022
 */

export const getTasaApproval2022 = (row) => {
  const tpbPoints = parseFloat(row['tasa']);
  return tpbPoints > 0;
};

export const isRMCPDGoal2022 = (row) => {
  const rmPoints = parseFloat(row[kaplanCpdCategories2022.RM.toLowerCase()]);
  return rmPoints > 0;
};

export const kaplanAccreditationDetails2022 = {
  AFA: 'Association of Financial Advisers (AFA)',
  CPA: 'Certified Practising Accountant (CPA)',
  CAANZ: 'Chartered Accountants Australia &amp; New Zealand (CA ANZ)',
  FAAA: 'Financial Advice Association Australia (FAAA)',
  FBAA: 'Finance Broker Association of Australia (FBAA)',
  FPA: 'Financial Planning Association (FPA)',
  MFAA: 'Mortgage &amp; Finance Association of Australia (MFAA)',
  NIBA: 'National Insurance Brokers Association (NIBA)',
  ASFA: 'The Association of Superannuation Funds of Australia (ASFA)',
  AFMA: 'The Australian Financial Markets Association (AFMA)',
  FINSIA: 'The Financial Services Institute of Australasia (FINSIA)',
  SMSFA: 'The SMSF Association (SMSFA)',
  SIAA: 'The Stockbrokers and Investment Advisers Association (SIAA)',
};

// Kaplan updated categories from 2022
const kaplanCpdCategories2022 = {
  TechnicalCompetence: 'Technical competence',
  TaxFinancialAdvice: 'Tax (Financial) Advice',
  RegulatoryCompliance: 'Regulatory compliance and consumer protection',
  Professionalism: 'Professionalism and ethics',
  General: 'General',
  ClientCare:'Client care and practice',
  AgedCare: 'Aged care',
  AlternativeAssets: 'Alternative assets',
  BehaviouralFinance : 'Behavioural finance',
  Cashflow: 'Cashflow and budgeting',
  ClientEngagement: 'Client engagement',
  Compliance: 'Compliance',
  ConsumerProtection: 'Consumer protection',
  Commodities: 'Commodities',
  DepositProducts: 'Deposit products and non-cash facilities',
  Derivatives: 'Derivatives',
  EconomicEnvironment: 'Economic environment',
  EstatePlanning: 'Estate planning',
  FinancialMarkets: 'Financial markets',
  FinancialPlanning: 'Financial planning',
  FixedInterest: 'Fixed Interest',
  ForeignExchange: 'Foreign exchange',
  Gearing: 'Gearing',
  GeneralInsurance: 'General Insurance',
  GenericKnowledge: 'Generic knowledge',
  IndustryTrends: 'Industry trends',
  Knowledge: 'Knowledge',
  LifeInsurance: 'Life Insurance',
  ManagedInvestments: 'Managed Investments',
  MarginLending: 'Margin lending',
  PersonalDevelopment: 'Personal Development',
  PracticeManagement: 'Practice Management',
  ProfessionalStandards: 'Professional standards',
  Property: 'Property',
  Regulatory : 'Regulatory',
  RegulatoryEnvironment: 'Regulatory environment',
  RM: 'Responsible manager',
  Retirement: 'Retirement',
  Securities: 'Securities',
  SMSF: 'Self Managed Superannuation Funds',
  Skills: 'Skills',
  SocialSecurity: 'Social security',
  Superannuation: 'Superannuation',
  Tax: 'Tax',
  Technology: 'Technology',
  Technical : 'Technical',
};

// Kaplan mapping from 2022
export const kaplanMapping2022 = {
  [kaplanCpdCategories2022.TechnicalCompetence]: {
    name: caddieCpdCategories.Technical,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.TaxFinancialAdvice]: {
    name: caddieCpdCategories.TaxFinancialAdvice,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.RegulatoryCompliance]: {
    name: caddieCpdCategories.Compliance,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Professionalism]: {
    name: caddieCpdCategories.Professionalism,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.General]: {
    name: caddieCpdCategories.General,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.ClientCare]: {
    name: caddieCpdCategories.ClientCare,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.AgedCare]: {
    name: caddieCpdCategories.AgedCare,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.AlternativeAssets]: {
    name: kaplanCpdCategories2022.AlternativeAssets,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.BehaviouralFinance]: {
    name: kaplanCpdCategories2022.BehaviouralFinance,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Cashflow]: {
    name: kaplanCpdCategories2022.Cashflow,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.ClientEngagement]: {
    name: kaplanCpdCategories2022.ClientEngagement,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Compliance]: {
    name: kaplanCpdCategories2022.Compliance,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.ConsumerProtection]: {
    name: kaplanCpdCategories2022.ConsumerProtection,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Commodities]: {
    name: kaplanCpdCategories2022.Commodities,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.DepositProducts]: {
    name: caddieCpdCategories.Deposits,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Derivatives]: {
    name: caddieCpdCategories.Derivatives,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.EconomicEnvironment]: {
    name: kaplanCpdCategories2022.EconomicEnvironment,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.EstatePlanning]: {
    name: caddieCpdCategories.EstatePlanning,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.FinancialMarkets]: {
    name: kaplanCpdCategories2022.FinancialMarkets,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.FinancialPlanning]: {
    name: caddieCpdCategories.FinancialPlanning,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.FixedInterest]: {
    name: kaplanCpdCategories2022.FixedInterest,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.ForeignExchange]: {
    name: caddieCpdCategories.ForeignExchange,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Gearing]: {
    name: kaplanCpdCategories2022.Gearing,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.GeneralInsurance]: {
    name: kaplanCpdCategories2022.GeneralInsurance,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.GenericKnowledge]: {
    name: caddieCpdCategories.GenericKnowledge,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.IndustryTrends]: {
    name: kaplanCpdCategories2022.IndustryTrends,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Knowledge]: {
    name: kaplanCpdCategories2022.Knowledge,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.LifeInsurance]: {
    name: caddieCpdCategories.Insurance,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.ManagedInvestments]: {
    name: caddieCpdCategories.ManagedInvestment,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.MarginLending]: {
    name: caddieCpdCategories.MarginLending,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.PersonalDevelopment]: {
    name: kaplanCpdCategories2022.PersonalDevelopment,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.PracticeManagement]: {
    name: caddieCpdCategories.PracticeManagement,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.ProfessionalStandards]: {
    name: kaplanCpdCategories2022.ProfessionalStandards,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Property]: {
    name: kaplanCpdCategories2022.Property,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Regulatory]: {
    name: kaplanCpdCategories2022.Regulatory,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.RegulatoryEnvironment]: {
    name: kaplanCpdCategories2022.RegulatoryEnvironment,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.RM]: {
    name: caddieCpdCategories.RM,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Retirement]: {
    name: caddieCpdCategories.Retirement,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Securities]: {
    name: caddieCpdCategories.Securities,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.SMSF]: {
    name: caddieCpdCategories.SMSF,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Skills]: {
    name: caddieCpdCategories.PersonalSkills,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.SocialSecurity]: {
    name: kaplanCpdCategories2022.SocialSecurity,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Superannuation]: {
    name: caddieCpdCategories.Superannuation,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Tax]: {
    name: caddieCpdCategories.Taxation,
    type: kaplanCpdType.import,
  },
  [kaplanCpdCategories2022.Technology]: {
    name: kaplanCpdCategories2022.Technology,
    type: kaplanCpdType.document,
  },
  [kaplanCpdCategories2022.Technical]: {
    name: kaplanCpdCategories2022.Technical,
    type: kaplanCpdType.document,
  },
};



// WEBPACK FOOTER //
// ./src/constants/kaplan-mapping.js